module.exports = __webpack_public_path__ + "img/353.6b8d72d0.png";